import { SearchType } from '@/constants/media';

export enum MainTab {
  EditPicture = 'EditPicture',
  CreativePicture = 'CreativePicture',
  EditVideo = 'EditVideo',
}

export enum SubTab {
  SINGLE = 'SINGLE',
  STORY = 'STORY',
  TOPIC = 'TOPIC',
}

export const SceneTypeMap = new Map([
  [SearchType.IMAGE, 'ic_image'],
  [SearchType.IMAGE_WEIGHTED, 'ic_image'],
  [SearchType.STORY, 'ic_image_story'],
  [SearchType.VIDEO, 'ic_video'],
  [SearchType.VIDEO_STORY, 'ic_video_story'],
  [SearchType.CREATIVE, 'ic_creative_image'],
  [SearchType.TOPIC, 'ic_image_topic'],
]);

export enum Composition {
  ADAPT,
  GRID,
}

export enum ImageWidth {
  ImgMaxWidth = 350,
}

/** 搜索接口字段 */
export enum FilterField {
  /** 开始时间 */
  BEGIN_TIME = 'beginTime', // ✅
  /** 创意图片的图片分类，只能选择一个分类 */
  IMAGE_CATEGORY = 'category', // ✅
  /** 编辑图片的频道ID集合，逗号分隔 */
  CATEGORY_IDS = 'categoryId', // ✅
  /** 创意图片中的颜色，16进制，不要#号 */
  COLOR = 'color', // ✅
  /** 是否仅看已编辑 */
  EDITED = 'edited', // ✅
  /** 截止日期 */
  EDN_TIME = 'endTime', // ✅
  /** 以图搜图ID */
  ID = 'id',
  /** 创意图片中的图片类型集合，逗号分隔 */
  IMAGE_TYPES = 'image_type', // ✅
  /** 构图类型集合，逗号分隔 */
  LAYOUTS = 'layout', // ✅
  /** 是否合并相似图片 */
  MERGE_SIMILAR = 'mergeSimilar', // ✅
  /** 未知 */
  NO_OVERWRITES = 'noOverwrites',
  /** 分页索引 */
  PAGE = 'page', // ✅
  /** 未知 */
  SEARCH_ID = 'searchId',
  /** 请求ID */
  REQUEST_ID = 'qid',
  /** 分页规格 */
  SIZE = 'size', // ✅
  /** 排序规则 */
  SORT_BY = 'sortBy', // ✅
  /** 搜索关键字 */
  TERM = 'term', // ✅
  /** 搜索类型，story、image、creative、video、videostory */
  TYPE = 'type', // ✅
  /** 视频分辨率 */
  VIDEO_FORMAT = 'video_format', // ✅
  /** TOKEN */
  XSRF_TOKEN = 'xsrfToken',
  /** 是否允许重排 */
  ENABLE_INTERVENE = 'enableIntervene',
  // 图片格式
  FORMAT = 'format',
  // 性别
  GENDER = 'gender',
  // 人数
  FACE_NUM = 'face_num',
  // 种族
  RACIAL = 'racial',
  // 年龄
  AGE = 'age',
  // AIGC
  IS_AIGC = 'isAigc',
  // 来源
  SOURCE = 'source',
}

// 对人物筛选的 map
export const hasPersonList: string[] = [
  FilterField.GENDER,
  FilterField.FACE_NUM,
  FilterField.RACIAL,
  FilterField.AGE,
];

export const TranslateTypeMap = new Map([
  [SearchType.IMAGE, SearchType.IMAGE],
  [SearchType.IMAGE_WEIGHTED, SearchType.IMAGE],
  [SearchType.STORY, SearchType.STORY],
  [SearchType.VIDEO, SearchType.IMAGE],
  [SearchType.VIDEO_STORY, SearchType.STORY],
  [SearchType.CREATIVE, SearchType.CREATIVE],
  [SearchType.TOPIC, SearchType.TOPIC],
]);

export const Fields = new Set(Object.values(FilterField));

export const DescriptionMap = new Map([
  [
    MainTab.EditPicture,
    {
      displayName: '编辑图片',
      icon: (
        <svg
          key={MainTab.EditPicture}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14 5H7a4 4 0 0 0-4 4v8a4 4 0 0 0 3.999 4h8.004C17.212 21 19 19.21 19 17v-7M17 5h4M18.997 2.897v4" />
            <path d="M9.286 17L15 11.286 12.714 9 7 14.714V17h2.286z" />
          </g>
        </svg>
      ),
      url: '/api/search',
      fields: new Set([
        FilterField.BEGIN_TIME,
        FilterField.CATEGORY_IDS,
        FilterField.EDN_TIME,
        FilterField.ID,
        FilterField.IMAGE_TYPES,
        FilterField.LAYOUTS,
        FilterField.PAGE,
        FilterField.SIZE,
        FilterField.SORT_BY,
        FilterField.TERM,
        FilterField.TYPE,
        FilterField.XSRF_TOKEN,
        FilterField.SOURCE,
      ]),
      children: new Map([
        [
          SubTab.SINGLE,
          {
            displayName: '图片',
            type: SearchType.IMAGE,
            sup: '',
          },
        ],
        [
          SubTab.STORY,
          {
            displayName: '组图',
            type: SearchType.STORY,
            sup: '',
          },
        ],
        [
          SubTab.TOPIC,
          {
            displayName: '专题',
            type: SearchType.TOPIC,
            sup: '',
          },
        ],
      ]),
    },
  ],
  [
    MainTab.CreativePicture,
    {
      displayName: '创意图片',
      icon: (
        <svg
          key={MainTab.CreativePicture}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M17 5h4M18.997 2.897v4" />
            <path d="M11 9l1.18 2.716 2.82.34-2.092 2.018.564 2.926L11 15.532 8.528 17l.564-2.926L7 12.056l2.82-.34L11 9z" />
            <path d="M14 5H7a4 4 0 0 0-4 4v8a4 4 0 0 0 3.999 4h8.004C17.212 21 19 19.21 19 17v-7" />
          </g>
        </svg>
      ),
      url: '/api/search',
      fields: new Set([
        FilterField.IMAGE_CATEGORY,
        FilterField.COLOR,
        FilterField.ID,
        FilterField.IMAGE_TYPES,
        FilterField.LAYOUTS,
        FilterField.PAGE,
        FilterField.SIZE,
        FilterField.SORT_BY,
        FilterField.TERM,
        FilterField.TYPE,
        FilterField.XSRF_TOKEN,
        FilterField.FORMAT,
        FilterField.GENDER,
        FilterField.FACE_NUM,
        FilterField.RACIAL,
        FilterField.AGE,
        FilterField.IS_AIGC,
      ]),
      children: new Map([
        [
          SubTab.SINGLE,
          {
            displayName: '图片',
            type: SearchType.CREATIVE,
            sup: '',
          },
        ],
      ]),
    },
  ],
  [
    MainTab.EditVideo,
    {
      displayName: '编辑视频',
      icon: (
        <svg
          key={MainTab.EditVideo}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M8.5 13v-2.277a1 1 0 0 1 1.496-.868L12 11l1.98 1.132a1 1 0 0 1 0 1.736L12 15l-2.004 1.145a1 1 0 0 1-1.496-.868V13z" />
            <path d="M14 5H7a4 4 0 0 0-4 4v8a4 4 0 0 0 3.999 4h8.004C17.212 21 19 19.21 19 17v-7M17 5h4M18.997 2.897v4" />
          </g>
        </svg>
      ),
      url: '/api/search/video',
      fields: new Set([
        FilterField.BEGIN_TIME,
        FilterField.EDN_TIME,
        FilterField.ID,
        FilterField.PAGE,
        FilterField.SIZE,
        FilterField.SORT_BY,
        FilterField.TERM,
        FilterField.TYPE,
        FilterField.VIDEO_FORMAT,
        FilterField.XSRF_TOKEN,
      ]),
      children: new Map([
        [
          SubTab.SINGLE,
          {
            displayName: '视频',
            type: SearchType.VIDEO,
            sup: '',
          },
        ],
        [
          SubTab.STORY,
          {
            displayName: '视频集',
            type: SearchType.VIDEO_STORY,
            sup: '',
          },
        ],
      ]),
    },
  ],
]);

/** 日期快捷键 */
export enum ShortcutTime {
  NoSelect = 'NoSelect',
  LastDay = 'LastDay',
  LastTwoDays = 'LastTwoDays',
  LastWeek = 'LastWeek',
  LastMonth = 'LastMonth',
  LastYear = 'LastYear',
  Custom = 'Custom',
}

export const ShortcutTimeDisplayNameMap = new Map([
  [ShortcutTime.LastDay, '最近24小时'],
  [ShortcutTime.LastTwoDays, '最近48小时'],
  [ShortcutTime.LastWeek, '最近7天'],
  [ShortcutTime.LastMonth, '最近一个月'],
  [ShortcutTime.LastYear, '最近一年'],
  [ShortcutTime.Custom, '自定义时间'],
]);

/** 构图 */
export const LayoutMap = new Map([
  [1, '横图'],
  [4, '竖图'],
  [8, '方图'],
]);

/** 频道 */
export const CategoryMap = new Map([
  [1, '国内'],
  [3, '国际'],
  // [7, '电影'],
  // [8, '精选'],
  [9, '体育'],
  [5, '娱乐'],
  [6, '时尚'],
  [2, '商业'],
  [4, '旅游'],
  // [10, '漫画图表'],
  // [262, '汽车'],
  [263, '精选档案'],
]);

// export const RoyaltyFreeMap = new Map([
//   [0, '全部'],
//   [2, 'RF'],
//   [1, 'RM'],
// ]);

/** 图片类型 */
export const ImageTypeMap = new Map([
  [2, '照片'],
  [3, '漫画/插画'],
  [0, 'AIGC'],
  [1, '矢量图'],
]);

export const ImageCategoryMap = new Map([
  [0, '全部'],
  [2016, '东方人物'],
  [2004, '风光旅行'],
  [2032, '美食蔬果'],
  [2128, '建筑设计'],
  [2064, '漫画插画'],
  [2008, '科技医疗'],
  [2002, '艺术经典'],
  [2001, '广告创意'],
]);

export const VideoFormatMap = new Map([
  [0, '全部'],
  [10, '4K'],
  [4, 'HD'],
]);

// 图片格式
export const PictureFormat = new Map([
  ['jpeg', 'JPEG'],
  ['eps', 'EPS'],
  ['psd', 'PSD'],
]);

// 性别
export const Gender = new Map([
  ['1', '男'],
  ['0', '女'],
]);

// 人数
export const FaceNum = new Map([
  ['0', '无'],
  ['1', '1 人'],
  ['2', '2 人'],
  ['3', '3 人及以上'],
]);

// 种族
export const Racial = new Map([
  ['0', '黑色人种'],
  ['1', '中东人'],
  ['2', '白色人种'],
  ['3', '亚洲人'],
]);

// 年龄
export const Age = new Map([
  ['1', '婴儿'],
  ['2', '儿童'],
  ['3', '少年'],
  ['4', '青年'],
  ['5', '中年'],
  ['6', '老年'],
]);

export const FilterMaps: Record<string, Map<number | string, string>> = {
  [FilterField.LAYOUTS]: LayoutMap,
  [FilterField.CATEGORY_IDS]: CategoryMap,
  [FilterField.IMAGE_TYPES]: ImageTypeMap,
  [FilterField.VIDEO_FORMAT]: VideoFormatMap,
  [FilterField.FORMAT]: PictureFormat,
  [FilterField.GENDER]: Gender,
  [FilterField.FACE_NUM]: FaceNum,
  [FilterField.RACIAL]: Racial,
  [FilterField.AGE]: Age,
};

export const SUCCESS_ICON = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.186 13.186A7.311 7.311 0 0 1 8 15.334c-1.97 0-3.82-.782-5.185-2.148A7.311 7.311 0 0 1 .667 8c0-1.97.782-3.82 2.148-5.185A7.311 7.311 0 0 1 8 .667c1.971 0 3.82.782 5.186 2.148A7.311 7.311 0 0 1 15.334 8c0 1.971-.782 3.82-2.148 5.186zm-7.38-5.657l1.528 1.528 3.528-3.528a.667.667 0 1 1 .943.943l-4 4a.667.667 0 0 1-.943 0l-2-2a.667.667 0 1 1 .943-.943z"
      fill="#3DCC9C"
    />
  </svg>
);

export const ERROR_ICON = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 15.334A7.333 7.333 0 1 0 8 .667a7.333 7.333 0 0 0 0 14.667z"
      fill="#EE2828"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.058 8L5.644 6.587a.667.667 0 1 1 .942-.942l1.415 1.414 1.414-1.414a.667.667 0 0 1 .943.942L8.943 8.001l1.415 1.414a.667.667 0 1 1-.943.943L8 8.943l-1.415 1.415a.667.667 0 0 1-.942-.943L7.058 8z"
      fill="#fff"
    />
  </svg>
);
